// extremely simple for now; we can use a library if we need for nouns with
// more complex pluralization rules
export function pluralize(noun, count) {
  if (count === 1) {
    return noun
  } else {
    return noun + 's'
  }
}
